function throwIfNotArrayField(store, fieldName) {
  const field = store.fields[fieldName];
  if (field?.type !== "arrayField" || !Array.isArray(field?.value)) {
    throw new Error(`Trying to change a non-array element, the method should be used only on arrayFields`);
  }
}
export {
  throwIfNotArrayField
};
//# sourceMappingURL=throwIfNotArrayField.js.map
